/**
 * The main api service
 */
import http from '@util/http';
import {core} from '../req';

/**
 * 用户列表
 */
export async function queryOrgUserList(params) {
  return http.get(core.ALL_USER_ORG_TREE, params);
}

/**
 * 用户列表
 */
export async function queryAccountList(params) {
  return http.get(core.ACCOUNT_LIST, params);
}

/**
 * 所有组织列表
 */
export async function queryUserOrgTreeList(params) {
  return http.get(core.USER_ORG_TREE, params);
}

/**
 * 角色列表
 */
export async function queryRoleList() {
  return http.get(core.ROLE_LIST);
}

/**
 * 获取用户登录信息
 */
export async function queryAccountInfo() {
  return http.get(core.ACCOUNT_INFO);
}

export async function queryUpdatePwd(params) {
  return http.post(core.CORE_ACCOUNT_UPDATE_PWD, params);
}

/**
 * 用户列表
 */
export async function queryCoreAccountSearch() {
  return http.get(core.CORE_ACCOUNT_SEARCH);
}

export async function queryAdminAccountList(params) {
  return http.get(core.GET_ADMIN_ACCOUNT_LIST, params);
}

export async function queryAdminAccountInfo(params) {
  return http.get(core.GET_ADMIN_ACCOUNT_INFO, params);
}

export async function querySaveAccount(params) {
  return http.post(core.SAVE_ACCOUNT, params);
}

export async function querySaveAccountRole(params) {
  return http.post(core.SAVE_BY_ACCOUNT_ACCOUNT_ROLE, params);
}

export async function querySaveAccountOrg(params) {
  return http.post(core.SAVE_BY_ACCOUNT_ACCOUNT_ORG, params);
}

export async function queryAccountOrgOrgs(params) {
  return http.get(core.GET_ACCOUNT_ORG_ORGS, params);
}

export async function queryAccountRoleRoles(params) {
  return http.get(core.GET_ACCOUNT_ROLE_ROLES, params);
}



// WEBPACK FOOTER //
// ./src/api/core/user.js